import React, { useEffect, useRef, useState } from "react";
import "./styles.scss";

interface VideoRendererProps {
  messageId: string;
  videoUrl: string;
}

export const VideoRenderer: React.FC<VideoRendererProps> = ({
  messageId,
  videoUrl,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showReplay, setShowReplay] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState<string | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      setIsVideoLoading(true);
      videoRef.current.load();
      videoRef.current.play().catch((err) => {
        console.error("Error playing video:", err);
        setVideoError(err.message);
        setIsVideoLoading(false);
      });
    }

    return () => videoRef.current?.pause();
  }, [videoUrl]);

  const handleEnded = () => {
    setIsPlaying(false);
    setShowReplay(true);
  };

  const handleReplay = () => {
    if (videoRef.current) {
      setShowReplay(false);
      setIsVideoLoading(true);
      videoRef.current.currentTime = 0;
      videoRef.current
        .play()
        .then(() => {
          setIsPlaying(true);
          setIsVideoLoading(false);
        })
        .catch((err) => {
          console.error("Error replaying video:", err);
          setVideoError(err.message);
          setIsVideoLoading(false);
        });
    }
  };

  return (
    <div className="videoContainer">
      {isVideoLoading && <div className="spinner large" />}
      <video
        ref={videoRef}
        src={videoUrl}
        className="video"
        controls={false}
        autoPlay
        onEnded={handleEnded}
        onLoadedData={() => setIsVideoLoading(false)}
      />
      {showReplay && !isVideoLoading && !isPlaying && (
        <button className="replayOverlay" onClick={handleReplay}>
          Replay
        </button>
      )}
    </div>
  );
};
